module.exports = __webpack_public_path__ + "static/media/15.4a885936.jpeg";